import { getPrivileges } from './localStorage';
import { isArrayValidAndNotEmpty, isTextValidAndNotEmpty } from './nullChecks';

const checkIfPrivilegeExistsForUser = (privilegesToCheck: Array<string>) => {
    const userPrivilegesString = getPrivileges();
    if (!isTextValidAndNotEmpty(userPrivilegesString)) {
        return false;
    }
    if (!isArrayValidAndNotEmpty(privilegesToCheck)) {
        return true;
    }

    const userPrivileges = userPrivilegesString.split(',');
    for (let index = 0; index < privilegesToCheck.length; index += 1) {
        if (!userPrivileges?.includes(privilegesToCheck[index])) {
            return false;
        }
    }
    return true;
};

export default checkIfPrivilegeExistsForUser;
